module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('nav', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_c('img', {
    staticClass: "a3d logo",
    attrs: {
      "src": "/static/img/siemens_logo_white.svg"
    }
  })]), _vm._v(" "), (_vm.clearCacheBanner) ? _c('div', {
    staticClass: "clear-cache"
  }, [_vm._v("\n          Please clear your browser cache to ensure you run with the latest AM Build Optimizer"), _c('sup', [_vm._v("TM")]), _vm._v(" updates!\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "hide-on-med-and-down a3d bold",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "nav-mobile"
    }
  }, [(_vm.webGL < 1) ? _c('li', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/dash/"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), (!_vm.subscription) ? _c('li', [_c('buy-credits', {
    staticClass: "menu-link"
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "menu-link",
    on: {
      "click": function($event) {
        return _vm.auth.logout()
      }
    }
  }, [_vm._v("Logout")])])])], 1), _vm._v(" "), (_vm.user.lastLogin) ? _c('div', {
    staticClass: "last-login right-align"
  }, [_vm._v("\n        Last login at: " + _vm._s(_vm._f("dateFormat")(_vm.user.lastLogin.date)) + " | " + _vm._s(_vm.user.lastLogin.geo) + " (" + _vm._s(_vm.user.lastLogin.ip) + ")\n      ")]) : _vm._e()]), _vm._v(" "), _c('banner'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "details-submitted",
      "height": "180px",
      "pivotY": 0.3
    }
  }, [_c('div', {
    staticClass: "row details-completed"
  }, [_c('div', {
    staticClass: "col s12 center-align details-completed-title"
  }, [_vm._v("\n          A sales representative will contact you shortly to set up payment\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "details",
      "height": "600px",
      "pivotY": 0.3
    },
    on: {
      "before-open": _vm.modalBeforeOpen
    }
  }, [_c('div', {
    staticClass: "row details"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align details-title"
  }, [_vm._v("\n            Billing information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "details-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.current),
      expression: "formData.name.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.name.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Company:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.company.current),
      expression: "formData.company.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.company.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.company, "current", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Address:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address.current),
      expression: "formData.address.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.address.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.address, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.address, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.address.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your address.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.phone.current),
      expression: "formData.phone.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.phone.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.phone, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.phone, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.phone.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your phone.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.current),
      expression: "formData.email.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.email.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.email, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.email.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your email.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [(!_vm.submitting) ? _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]) : _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webgl-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webgl-warning-message-wrp"
  }, [_c('div', {
    staticClass: "webgl-warning-message"
  }, [_vm._v("WebGL is unavailable.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f482306", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f482306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 482
// module chunks = 1